import React from 'react';

import { Layout } from 'components/Layout';
import { HowToCards } from 'components/sections/HowToCards';
import { reviews } from 'content/reviews';
import { Reviews } from 'components/sections/Reviews';
import { Image } from 'components/sections/Image';
import { Magazine, MagazineArticleCard } from 'components/sections/Magazine';
import { Faq, Topic } from 'components/sections/Faq';
import { howToCardsLoan } from 'content/howToCards';
import { Gutter } from 'components/Gutter';
import useMediaQuery from 'utils/useMediaQuery';
import { LoanHero } from 'components/sections/LoanHero';
import { carLoanQuotes } from 'content/quotes';
import { Quote } from 'components/Quote';

interface Props {
  articles: MagazineArticleCard[];
  faq: {
    title: string;
    questions: Topic[];
  };
}

export const CarLoan: React.FC<Props> = ({ articles, faq }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Layout>
      <LoanHero />
      <Gutter size="medium">
        <Quote text={carLoanQuotes[0].text} byline={carLoanQuotes[0].byline} />
      </Gutter>

      <Gutter size="medium">
        <HowToCards
          title={howToCardsLoan.title}
          howToItems={howToCardsLoan.howToItems}
          hideImages
          showBg
          showIcons
        />
      </Gutter>

      <Gutter size="large">
        <Reviews title={reviews.title} reviews={reviews.reviews} />
      </Gutter>

      <Gutter size="large">
        {isMobile ? (
          <Image
            rounded
            src="/assets/images/my-ride-my-rules-mobile.jpg"
            alt="An electric car and two people in front of a wooden house"
            title="My ride. My rules."
            intro="Att ha en egen bil ska göra dig fri, inte begränsad."
          />
        ) : (
          <Image
            rounded
            src="/assets/images/my-ride-my-rules-desktop.jpg"
            alt="An electric car and two people in front of a wooden house"
            title="My ride. My rules."
            intro="Att ha en egen bil ska göra dig fri, inte begränsad."
          />
        )}
      </Gutter>
      <Gutter size="large">
        <Magazine articles={articles} />
      </Gutter>
      <Gutter size="large">
        <Faq title={faq.title} questions={faq.questions} />
      </Gutter>
    </Layout>
  );
};
